/**
 * Countries data for country selection modal.
 * Based on wp_vk_countries table with ISO 3166-1 alpha-2 codes.
 */

export interface CountryOption {
    code: string   // ISO 3166-1 alpha-2
    name: string   // Display name (Russian)
    nameEn: string // English name for search
}

/**
 * Full list of countries matching wp_vk_countries table.
 * Ordered by Russian alphabet (same as database).
 */
export const COUNTRIES: CountryOption[] = [
    { code: 'RU', name: 'Россия', nameEn: 'Russia' },
    { code: 'UA', name: 'Украина', nameEn: 'Ukraine' },
    { code: 'BY', name: 'Беларусь', nameEn: 'Belarus' },
    { code: 'KZ', name: 'Казахстан', nameEn: 'Kazakhstan' },
    { code: 'AZ', name: 'Азербайджан', nameEn: 'Azerbaijan' },
    { code: 'AM', name: 'Армения', nameEn: 'Armenia' },
    { code: 'GE', name: 'Грузия', nameEn: 'Georgia' },
    { code: 'IL', name: 'Израиль', nameEn: 'Israel' },
    { code: 'US', name: 'США', nameEn: 'USA' },
    { code: 'CA', name: 'Канада', nameEn: 'Canada' },
    { code: 'KG', name: 'Кыргызстан', nameEn: 'Kyrgyzstan' },
    { code: 'LV', name: 'Латвия', nameEn: 'Latvia' },
    { code: 'LT', name: 'Литва', nameEn: 'Lithuania' },
    { code: 'EE', name: 'Эстония', nameEn: 'Estonia' },
    { code: 'MD', name: 'Молдова', nameEn: 'Moldova' },
    { code: 'TJ', name: 'Таджикистан', nameEn: 'Tajikistan' },
    { code: 'TM', name: 'Туркменистан', nameEn: 'Turkmenistan' },
    { code: 'UZ', name: 'Узбекистан', nameEn: 'Uzbekistan' },
    { code: 'AU', name: 'Австралия', nameEn: 'Australia' },
    { code: 'AT', name: 'Австрия', nameEn: 'Austria' },
    { code: 'AL', name: 'Албания', nameEn: 'Albania' },
    { code: 'DZ', name: 'Алжир', nameEn: 'Algeria' },
    { code: 'AS', name: 'Американское Самоа', nameEn: 'American Samoa' },
    { code: 'AI', name: 'Ангилья', nameEn: 'Anguilla' },
    { code: 'AO', name: 'Ангола', nameEn: 'Angola' },
    { code: 'AD', name: 'Андорра', nameEn: 'Andorra' },
    { code: 'AG', name: 'Антигуа и Барбуда', nameEn: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Аргентина', nameEn: 'Argentina' },
    { code: 'AW', name: 'Аруба', nameEn: 'Aruba' },
    { code: 'AF', name: 'Афганистан', nameEn: 'Afghanistan' },
    { code: 'BS', name: 'Багамы', nameEn: 'Bahamas' },
    { code: 'BD', name: 'Бангладеш', nameEn: 'Bangladesh' },
    { code: 'BB', name: 'Барбадос', nameEn: 'Barbados' },
    { code: 'BH', name: 'Бахрейн', nameEn: 'Bahrain' },
    { code: 'BZ', name: 'Белиз', nameEn: 'Belize' },
    { code: 'BE', name: 'Бельгия', nameEn: 'Belgium' },
    { code: 'BJ', name: 'Бенин', nameEn: 'Benin' },
    { code: 'BM', name: 'Бермуды', nameEn: 'Bermuda' },
    { code: 'BG', name: 'Болгария', nameEn: 'Bulgaria' },
    { code: 'BO', name: 'Боливия', nameEn: 'Bolivia' },
    { code: 'BA', name: 'Босния и Герцеговина', nameEn: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Ботсвана', nameEn: 'Botswana' },
    { code: 'BR', name: 'Бразилия', nameEn: 'Brazil' },
    { code: 'BN', name: 'Бруней-Даруссалам', nameEn: 'Brunei' },
    { code: 'BF', name: 'Буркина-Фасо', nameEn: 'Burkina Faso' },
    { code: 'BI', name: 'Бурунди', nameEn: 'Burundi' },
    { code: 'BT', name: 'Бутан', nameEn: 'Bhutan' },
    { code: 'VU', name: 'Вануату', nameEn: 'Vanuatu' },
    { code: 'GB', name: 'Великобритания', nameEn: 'United Kingdom' },
    { code: 'HU', name: 'Венгрия', nameEn: 'Hungary' },
    { code: 'VE', name: 'Венесуэла', nameEn: 'Venezuela' },
    { code: 'VG', name: 'Виргинские острова (Брит.)', nameEn: 'Virgin Islands, British' },
    { code: 'VI', name: 'Виргинские острова (США)', nameEn: 'Virgin Islands, US' },
    { code: 'TL', name: 'Восточный Тимор', nameEn: 'East Timor' },
    { code: 'VN', name: 'Вьетнам', nameEn: 'Vietnam' },
    { code: 'GA', name: 'Габон', nameEn: 'Gabon' },
    { code: 'HT', name: 'Гаити', nameEn: 'Haiti' },
    { code: 'GY', name: 'Гайана', nameEn: 'Guyana' },
    { code: 'GM', name: 'Гамбия', nameEn: 'Gambia' },
    { code: 'GH', name: 'Гана', nameEn: 'Ghana' },
    { code: 'GP', name: 'Гваделупа', nameEn: 'Guadeloupe' },
    { code: 'GT', name: 'Гватемала', nameEn: 'Guatemala' },
    { code: 'GN', name: 'Гвинея', nameEn: 'Guinea' },
    { code: 'GW', name: 'Гвинея-Бисау', nameEn: 'Guinea-Bissau' },
    { code: 'DE', name: 'Германия', nameEn: 'Germany' },
    { code: 'GI', name: 'Гибралтар', nameEn: 'Gibraltar' },
    { code: 'HN', name: 'Гондурас', nameEn: 'Honduras' },
    { code: 'HK', name: 'Гонконг', nameEn: 'Hong Kong' },
    { code: 'GD', name: 'Гренада', nameEn: 'Grenada' },
    { code: 'GL', name: 'Гренландия', nameEn: 'Greenland' },
    { code: 'GR', name: 'Греция', nameEn: 'Greece' },
    { code: 'GU', name: 'Гуам', nameEn: 'Guam' },
    { code: 'DK', name: 'Дания', nameEn: 'Denmark' },
    { code: 'DJ', name: 'Джибути', nameEn: 'Djibouti' },
    { code: 'DM', name: 'Доминика', nameEn: 'Dominica' },
    { code: 'DO', name: 'Доминиканская Республика', nameEn: 'Dominican Republic' },
    { code: 'EG', name: 'Египет', nameEn: 'Egypt' },
    { code: 'ZM', name: 'Замбия', nameEn: 'Zambia' },
    { code: 'EH', name: 'Западная Сахара', nameEn: 'Western Sahara' },
    { code: 'ZW', name: 'Зимбабве', nameEn: 'Zimbabwe' },
    { code: 'IN', name: 'Индия', nameEn: 'India' },
    { code: 'ID', name: 'Индонезия', nameEn: 'Indonesia' },
    { code: 'JO', name: 'Иордания', nameEn: 'Jordan' },
    { code: 'IQ', name: 'Ирак', nameEn: 'Iraq' },
    { code: 'IR', name: 'Иран', nameEn: 'Iran' },
    { code: 'IE', name: 'Ирландия', nameEn: 'Ireland' },
    { code: 'IS', name: 'Исландия', nameEn: 'Iceland' },
    { code: 'ES', name: 'Испания', nameEn: 'Spain' },
    { code: 'IT', name: 'Италия', nameEn: 'Italy' },
    { code: 'YE', name: 'Йемен', nameEn: 'Yemen' },
    { code: 'CV', name: 'Кабо-Верде', nameEn: 'Cape Verde' },
    { code: 'KH', name: 'Камбоджа', nameEn: 'Cambodia' },
    { code: 'CM', name: 'Камерун', nameEn: 'Cameroon' },
    { code: 'QA', name: 'Катар', nameEn: 'Qatar' },
    { code: 'KE', name: 'Кения', nameEn: 'Kenya' },
    { code: 'CY', name: 'Кипр', nameEn: 'Cyprus' },
    { code: 'KI', name: 'Кирибати', nameEn: 'Kiribati' },
    { code: 'CN', name: 'Китай', nameEn: 'China' },
    { code: 'CO', name: 'Колумбия', nameEn: 'Colombia' },
    { code: 'KM', name: 'Коморы', nameEn: 'Comoros' },
    { code: 'CG', name: 'Конго', nameEn: 'Congo' },
    { code: 'CD', name: 'Конго (ДР)', nameEn: 'Congo, Democratic Republic' },
    { code: 'CR', name: 'Коста-Рика', nameEn: 'Costa Rica' },
    { code: 'CI', name: 'Кот-д\'Ивуар', nameEn: 'Côte d\'Ivoire' },
    { code: 'CU', name: 'Куба', nameEn: 'Cuba' },
    { code: 'KW', name: 'Кувейт', nameEn: 'Kuwait' },
    { code: 'CW', name: 'Кюрасао', nameEn: 'Curacao' },
    { code: 'LA', name: 'Лаос', nameEn: 'Laos' },
    { code: 'LS', name: 'Лесото', nameEn: 'Lesotho' },
    { code: 'LR', name: 'Либерия', nameEn: 'Liberia' },
    { code: 'LB', name: 'Ливан', nameEn: 'Lebanon' },
    { code: 'LY', name: 'Ливия', nameEn: 'Libya' },
    { code: 'LI', name: 'Лихтенштейн', nameEn: 'Liechtenstein' },
    { code: 'LU', name: 'Люксембург', nameEn: 'Luxembourg' },
    { code: 'MU', name: 'Маврикий', nameEn: 'Mauritius' },
    { code: 'MR', name: 'Мавритания', nameEn: 'Mauritania' },
    { code: 'MG', name: 'Мадагаскар', nameEn: 'Madagascar' },
    { code: 'MO', name: 'Макао', nameEn: 'Macau' },
    { code: 'MK', name: 'Македония', nameEn: 'Macedonia' },
    { code: 'MW', name: 'Малави', nameEn: 'Malawi' },
    { code: 'MY', name: 'Малайзия', nameEn: 'Malaysia' },
    { code: 'ML', name: 'Мали', nameEn: 'Mali' },
    { code: 'MV', name: 'Мальдивы', nameEn: 'Maldives' },
    { code: 'MT', name: 'Мальта', nameEn: 'Malta' },
    { code: 'MA', name: 'Марокко', nameEn: 'Morocco' },
    { code: 'MQ', name: 'Мартиника', nameEn: 'Martinique' },
    { code: 'MH', name: 'Маршалловы Острова', nameEn: 'Marshall Islands' },
    { code: 'MX', name: 'Мексика', nameEn: 'Mexico' },
    { code: 'FM', name: 'Микронезия', nameEn: 'Micronesia' },
    { code: 'MZ', name: 'Мозамбик', nameEn: 'Mozambique' },
    { code: 'MC', name: 'Монако', nameEn: 'Monaco' },
    { code: 'MN', name: 'Монголия', nameEn: 'Mongolia' },
    { code: 'MS', name: 'Монтсеррат', nameEn: 'Montserrat' },
    { code: 'MM', name: 'Мьянма', nameEn: 'Myanmar' },
    { code: 'NA', name: 'Намибия', nameEn: 'Namibia' },
    { code: 'NR', name: 'Науру', nameEn: 'Nauru' },
    { code: 'NP', name: 'Непал', nameEn: 'Nepal' },
    { code: 'NE', name: 'Нигер', nameEn: 'Niger' },
    { code: 'NG', name: 'Нигерия', nameEn: 'Nigeria' },
    { code: 'NL', name: 'Нидерланды', nameEn: 'Netherlands' },
    { code: 'NI', name: 'Никарагуа', nameEn: 'Nicaragua' },
    { code: 'NU', name: 'Ниуэ', nameEn: 'Niue' },
    { code: 'NZ', name: 'Новая Зеландия', nameEn: 'New Zealand' },
    { code: 'NC', name: 'Новая Каледония', nameEn: 'New Caledonia' },
    { code: 'NO', name: 'Норвегия', nameEn: 'Norway' },
    { code: 'AE', name: 'ОАЭ', nameEn: 'United Arab Emirates' },
    { code: 'OM', name: 'Оман', nameEn: 'Oman' },
    { code: 'IM', name: 'Остров Мэн', nameEn: 'Isle of Man' },
    { code: 'NF', name: 'Остров Норфолк', nameEn: 'Norfolk Island' },
    { code: 'KY', name: 'Острова Кайман', nameEn: 'Cayman Islands' },
    { code: 'CK', name: 'Острова Кука', nameEn: 'Cook Islands' },
    { code: 'TC', name: 'Острова Теркс и Кайкос', nameEn: 'Turks and Caicos Islands' },
    { code: 'PK', name: 'Пакистан', nameEn: 'Pakistan' },
    { code: 'PW', name: 'Палау', nameEn: 'Palau' },
    { code: 'PS', name: 'Палестина', nameEn: 'Palestinian Territory' },
    { code: 'PA', name: 'Панама', nameEn: 'Panama' },
    { code: 'PG', name: 'Папуа — Новая Гвинея', nameEn: 'Papua New Guinea' },
    { code: 'PY', name: 'Парагвай', nameEn: 'Paraguay' },
    { code: 'PE', name: 'Перу', nameEn: 'Peru' },
    { code: 'PN', name: 'Питкерн', nameEn: 'Pitcairn' },
    { code: 'PL', name: 'Польша', nameEn: 'Poland' },
    { code: 'PT', name: 'Португалия', nameEn: 'Portugal' },
    { code: 'PR', name: 'Пуэрто-Рико', nameEn: 'Puerto Rico' },
    { code: 'RE', name: 'Реюньон', nameEn: 'Reunion' },
    { code: 'RW', name: 'Руанда', nameEn: 'Rwanda' },
    { code: 'RO', name: 'Румыния', nameEn: 'Romania' },
    { code: 'SV', name: 'Сальвадор', nameEn: 'El Salvador' },
    { code: 'WS', name: 'Самоа', nameEn: 'Samoa' },
    { code: 'SM', name: 'Сан-Марино', nameEn: 'San Marino' },
    { code: 'ST', name: 'Сан-Томе и Принсипи', nameEn: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Саудовская Аравия', nameEn: 'Saudi Arabia' },
    { code: 'SZ', name: 'Свазиленд', nameEn: 'Swaziland' },
    { code: 'SH', name: 'Святая Елена', nameEn: 'Saint Helena' },
    { code: 'KP', name: 'Северная Корея', nameEn: 'North Korea' },
    { code: 'MP', name: 'Северные Марианские острова', nameEn: 'Northern Mariana Islands' },
    { code: 'SC', name: 'Сейшелы', nameEn: 'Seychelles' },
    { code: 'SN', name: 'Сенегал', nameEn: 'Senegal' },
    { code: 'VC', name: 'Сент-Винсент', nameEn: 'Saint Vincent' },
    { code: 'KN', name: 'Сент-Китс и Невис', nameEn: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Сент-Люсия', nameEn: 'Saint Lucia' },
    { code: 'PM', name: 'Сен-Пьер и Микелон', nameEn: 'Saint Pierre and Miquelon' },
    { code: 'RS', name: 'Сербия', nameEn: 'Serbia' },
    { code: 'SG', name: 'Сингапур', nameEn: 'Singapore' },
    { code: 'SX', name: 'Синт-Мартен', nameEn: 'Sint Maarten' },
    { code: 'SY', name: 'Сирия', nameEn: 'Syria' },
    { code: 'SK', name: 'Словакия', nameEn: 'Slovakia' },
    { code: 'SI', name: 'Словения', nameEn: 'Slovenia' },
    { code: 'SB', name: 'Соломоновы Острова', nameEn: 'Solomon Islands' },
    { code: 'SO', name: 'Сомали', nameEn: 'Somalia' },
    { code: 'SD', name: 'Судан', nameEn: 'Sudan' },
    { code: 'SR', name: 'Суринам', nameEn: 'Suriname' },
    { code: 'SL', name: 'Сьерра-Леоне', nameEn: 'Sierra Leone' },
    { code: 'TH', name: 'Таиланд', nameEn: 'Thailand' },
    { code: 'TW', name: 'Тайвань', nameEn: 'Taiwan' },
    { code: 'TZ', name: 'Танзания', nameEn: 'Tanzania' },
    { code: 'TG', name: 'Того', nameEn: 'Togo' },
    { code: 'TK', name: 'Токелау', nameEn: 'Tokelau' },
    { code: 'TO', name: 'Тонга', nameEn: 'Tonga' },
    { code: 'TT', name: 'Тринидад и Тобаго', nameEn: 'Trinidad and Tobago' },
    { code: 'TV', name: 'Тувалу', nameEn: 'Tuvalu' },
    { code: 'TN', name: 'Тунис', nameEn: 'Tunisia' },
    { code: 'TR', name: 'Турция', nameEn: 'Turkey' },
    { code: 'UG', name: 'Уганда', nameEn: 'Uganda' },
    { code: 'WF', name: 'Уоллис и Футуна', nameEn: 'Wallis and Futuna' },
    { code: 'UY', name: 'Уругвай', nameEn: 'Uruguay' },
    { code: 'FO', name: 'Фарерские острова', nameEn: 'Faroe Islands' },
    { code: 'FJ', name: 'Фиджи', nameEn: 'Fiji' },
    { code: 'PH', name: 'Филиппины', nameEn: 'Philippines' },
    { code: 'FI', name: 'Финляндия', nameEn: 'Finland' },
    { code: 'FK', name: 'Фолклендские острова', nameEn: 'Falkland Islands' },
    { code: 'FR', name: 'Франция', nameEn: 'France' },
    { code: 'GF', name: 'Французская Гвиана', nameEn: 'French Guiana' },
    { code: 'PF', name: 'Французская Полинезия', nameEn: 'French Polynesia' },
    { code: 'HR', name: 'Хорватия', nameEn: 'Croatia' },
    { code: 'CF', name: 'ЦАР', nameEn: 'Central African Republic' },
    { code: 'TD', name: 'Чад', nameEn: 'Chad' },
    { code: 'ME', name: 'Черногория', nameEn: 'Montenegro' },
    { code: 'CZ', name: 'Чехия', nameEn: 'Czech Republic' },
    { code: 'CL', name: 'Чили', nameEn: 'Chile' },
    { code: 'CH', name: 'Швейцария', nameEn: 'Switzerland' },
    { code: 'SE', name: 'Швеция', nameEn: 'Sweden' },
    { code: 'SJ', name: 'Шпицберген и Ян Майен', nameEn: 'Svalbard and Jan Mayen' },
    { code: 'LK', name: 'Шри-Ланка', nameEn: 'Sri Lanka' },
    { code: 'EC', name: 'Эквадор', nameEn: 'Ecuador' },
    { code: 'GQ', name: 'Экваториальная Гвинея', nameEn: 'Equatorial Guinea' },
    { code: 'ER', name: 'Эритрея', nameEn: 'Eritrea' },
    { code: 'ET', name: 'Эфиопия', nameEn: 'Ethiopia' },
    { code: 'ZA', name: 'ЮАР', nameEn: 'South Africa' },
    { code: 'SS', name: 'Южный Судан', nameEn: 'South Sudan' },
    { code: 'KR', name: 'Южная Корея', nameEn: 'South Korea' },
    { code: 'JM', name: 'Ямайка', nameEn: 'Jamaica' },
    { code: 'JP', name: 'Япония', nameEn: 'Japan' },
    { code: 'VA', name: 'Ватикан', nameEn: 'Vatican' },
    { code: 'BQ', name: 'Бонайре, Синт-Эстатиус и Саба', nameEn: 'Bonaire, Sint Eustatius and Saba' },
]


